<template>
  <div>
    <Breadcrumbs main="matchTx.dashboard" title="matchTx.header" />
    <b-container fluid>
      <!-- <h3 class="mb-1 mt-4 f-w-600">{{ $t('matchTx.header') }}</h3> -->
      <div class="row">
        <div class="ml-3 mt-1" > 
          <span for="selectedCompName" class=" text-primary pt-0 f-w-600" style="font-size: 20px">{{ $t("register.compId") }}</span>          
        </div>
        <div class="col-sm-5 ml-3">
          <v-select label="selectedCompName" v-model="selectedCompName" :options="compNameListLogist" @input="matchTxAdmin" class=" text-primary pt-0 f-w-600" style="font-size: 20px;">
          </v-select>     
        </div>
        <!-- <div class=" ml-3">
          <button @click="matchTxAdmin" class="btn btn-primary btn-lg active" type="button"><i class="fa fa-star"></i> Run</button>
        </div>         -->
      </div>
      <div>
      <h2 class="mb-1 mt-4 f-w-600">{{ $t('matchTx.reqrReceiver') }}</h2>
      <b-table
        sticky-header
        head-variant="light"
        table-variant="info"
        show-empty
        responsive
        sort-icon-left
        stacked="md"
        :sort-by.sync="sortByReqr"
        :sort-desc.sync="sortDescReqr"
        :items="itemsReqr"
        :fields="fieldsReqr"
        :current-page="currentPageReqr"
        :per-page="perPageReqr"
      >
        <template #cell(addressReqr)="row" >
            <b-button size="sm"   v-b-popover.hover.top="row.item.contReqrAddress" variant="outline-info">
                {{ $t('matchTx.reqr') }}
            </b-button>
          </template>
          <template #cell(addressRels)="row" >
            <b-button  size="sm" v-b-popover.hover.top="row.item.contRelsAddress" variant="outline-info">
                {{ $t('matchTx.rels') }}
            </b-button>
          </template>
        <template #cell(contImageReqr)="row" >
          <b-button  size="sm" @click="openModalImageReqr(row.item, row.index, $event.target )" class="m-1" v-b-popover.hover.top="`${$t('container.contId')} : ${row.item.contId}`">
              {{ row.item.contNo }}
          </b-button>
        </template>
        <template #cell(transCompNameReqr)="row" >
            <b-button  size="md" @click="openModalTransCompReqr(row.item, row.index, $event.target )" class="m-1">
                {{ row.item.transCompId }}
            </b-button>
          </template>
        <template #cell(actReqr)="row" >
          <b-button  v-show="row.item.actReqr.cancel" size="sm" variant="danger" @click="actReqrCancel(row.item)" class="m-1 ">
            {{ $t('matchTx.cancel') }}
          </b-button>
          <b-button  v-show="row.item.actReqr.accept" size="sm" variant="success" @click="actReqrAccept(row.item)" class="m-1">
            {{ $t('matchTx.accept') }}
          </b-button>
          <b-button  v-show="row.item.actReqr.reject" size="sm" variant="danger" @click="actReqrReject(row.item)" class="m-1">
            {{ $t('matchTx.reject') }}
          </b-button>
          <b-button  v-show="row.item.actReqr.attachSeal" size="sm" variant="warning" @click="actReqrAttachSeal(row.item)" class="m-1">
            {{ $t('matchTx.attachSeal') }}
          </b-button>
          <b-button  v-show="row.item.actReqr.terminate" size="sm" variant="danger" @click="actReqrTerminate(row.item)" class="m-1">
            {{ $t('matchTx.terminate') }}
          </b-button>
          <b-button  v-show="row.item.actReqr.transfer" size="sm" variant="warning" @click="actReqrTransfer(row.item)" class="m-1">
            {{ $t('matchTx.transfer') }}
          </b-button>
          <b-button v-show="row.item.jbReqr == 'shipsRej'" size="md" variant="warning" @click="openModalViewShipsRejectReqr(row.item, row.index, $event.target )" class="m-1">
              {{ $t('matchTx.viewShipsReject') }}
            </b-button>
        </template>
        <template #empty>
            <h5>{{ $t('reuse.noRecord') }}</h5>
        </template>
      </b-table>
      <b-row>
        <div class="row col-sm-8 ">
          <b-col class="my-1 ml-3">
            <b-pagination
              v-model="currentPageReqr"
              :total-rows="totalRowsReqr"
              :per-page="perPageReqr"
              align="fill"
              class="my-0"
            ></b-pagination>
          </b-col>   
          <b-col sm="3" md="6" class="my-1">
            <b-form-group
              :label= "$t('require.perPage')"
              label-for="per-page-select"
              label-cols-sm="6"
              label-cols-md="4"
              label-cols-lg="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0"
            >
              <b-form-select
                id="per-page-select"
                v-model="perPageReqr"
                :options="pageOptionsReqr"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </div>
      </b-row>
      <div>
        <!-- <b-button @click="showSealNoModal=true" variant="primary">Show Modal</b-button> -->
        <!-- <b-modal
          :id="actReqrAttachSealModal.id" 
          :title="actReqrAttachSealModal.title"
          v-model="showSealNoModal"
          header-bg-variant="info"
          header-text-variant="dark"
          body-bg-variant="light"
          body-text-variant="dark"
          hide-footer
        >
          <b-row class="mb-1">
            <b-col cols="4">{{ $t('matchTx.selSealNo') }}</b-col>
            <b-col>
              <b-form-select
                v-model="selectedSealNo"
                :options="sealNos"
              ></b-form-select>
            </b-col>
          </b-row>
          <div class="w-100">
            <span class="float-left">{{$t('matchTx.sealNo')}} : </span> <span> {{ selectedSealNo }}</span> 
            <b-button
              variant="primary"
              size="sm"
              class="float-right"
              @click="clickAttachSeal_OK"
            >
              OK
            </b-button>
          </div>
        </b-modal> -->
        <!-- <b-modal
          :id="actReqrTransferModal.id" 
          :title="actReqrTransferModal.title"
          v-model="showTransferModal"
          header-bg-variant="info"
          header-text-variant="dark"
          body-bg-variant="light"
          body-text-variant="dark"
          hide-footer
        >
          <b-row class="mb-1">
            <b-col cols="4">{{ $t('matchTx.selBkgId') }}</b-col>
            <b-col>
              <b-form-select
                v-model="selectedBkgId"
                :options="bkgIds"
              ></b-form-select>
            </b-col>
          </b-row>
          <div class="w-100">
            <span class="float-left">{{$t('matchTx.bkgId')}} : </span> <span> {{ selectedBkgId }}</span> 
            <b-button
              variant="primary"
              size="sm"
              class="float-right"
              @click="clickBkgId_OK"
            >
              OK
            </b-button>
          </div>
        </b-modal> -->
        <b-modal id="contModalReqr" :title="modalTitleReqr" ok-only @hide="resetInfoModalReqr">
          <div class="row my-2 ml-1">
              <h5 class="text-primary ml-3"> {{ $t('container.contId') }} : </h5>               
              <span class="text-primary ml-2">{{ modalContIdReqr }}</span>                  
            </div>
          <div class="gradient-yg p-1" >
                <div class="dashboard">
                    <div class="image-scroll-container">
                        <div class="image-scroll" ref="scrollContainer">
                            <div
                            class="image-item"
                            v-for="(image, index) in imageUriModalReqr"
                            :key="image.id"
                            >
                            <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                            <span class="image-counter">{{ index + 1 }} of {{ imageUriModalReqr.length }}</span>
                            </div>
                            <div v-if="imageUriModalReqr.length === 0" class="no-images">
                            {{$t('approvedTrans.noImageYet') }}
                            </div>
                        </div>
                        <div class="scroll-controls" v-if="imageUriModalReqr.length > 1">
                            <button @click="scrollLeft" class="scroll-btn">&lt;&lt;</button>
                            <button @click="scrollLeftS1" class="scroll-btn mx-2">&lt;</button>
                            <button @click="scrollRightS1" class="scroll-btn mx-2">&gt;</button>
                            <button @click="scrollRight" class="scroll-btn">&gt;&gt;</button>
                        </div>
                    </div>                        
                </div>
            </div>
        </b-modal>
        <b-modal id="contModalRels" :title="modalTitleRels" ok-only @hide="resetInfoModalRels">
          <div class="row my-2 ml-1">
              <h5 class="text-primary ml-2"> {{ $t('container.contId') }} : </h5>               
              <span class="text-primary ml-2">{{ modalContIdRels }}</span>                  
            </div>
          <div class="gradient-yg p-1" >
                <div class="dashboard">
                    <div class="image-scroll-container">
                        <div class="image-scroll" ref="scrollContainer">
                            <div
                            class="image-item"
                            v-for="(image, index) in imageUriModalRels"
                            :key="image.id"
                            >
                            <img :src="image.url" :alt="'Image ' + (index + 1)" class="display-image">
                            <span class="image-counter">{{ index + 1 }} of {{ imageUriModalRels.length }}</span>
                            </div>
                            <div v-if="imageUriModalRels.length === 0" class="no-images">
                            {{$t('approvedTrans.noImageYet') }}
                            </div>
                        </div>
                        <div class="scroll-controls" v-if="imageUriModalRels.length > 1">
                            <button @click="scrollLeft" class="scroll-btn">&lt;&lt;</button>
                            <button @click="scrollLeftS1" class="scroll-btn mx-2">&lt;</button>
                            <button @click="scrollRightS1" class="scroll-btn mx-2">&gt;</button>
                            <button @click="scrollRight" class="scroll-btn">&gt;&gt;</button>
                        </div>
                    </div>                        
                </div>
            </div>
        </b-modal>
        <b-modal id="viewShipsRejectModalReqr" :title="$t('matchTx.viewShipsRejectTitle')" ok-only @hide="resetInfoModalShipsRejectReqr">
          <div class="card me-5" style=" width:30rem">
              <h6 class="card me-5"> {{ shipsRejectRemarkReqr }}</h6>
          </div>
        </b-modal>
        <b-modal id="viewShipsRejectModalRels" :title="$t('matchTx.viewShipsRejectTitle')" ok-only @hide="resetInfoModalShipsRejectRels">
          <div class="card me-5" style=" width:30rem">
              <h6 class="card me-5"> {{ shipsRejectRemarkRels   }}</h6>
          </div>
        </b-modal>
        <b-modal id="transCompModalRels" header-text-variant="primary" :title="$t('matchTx.transComp')" ok-only @hide="resetInfoModalTransCompRels">
            <div class="card me-5" style=" width:30rem">
                <h6 class="card me-5"> {{ transCompInfoRels.compNameLocal }}</h6>
                <h6 class="card me-5"> {{ transCompInfoRels.compNameEng }}</h6>
                <div class=" row ml-2"> 
                  <h5 class="text-primary"> {{ $t('company.contactEmail') }} :</h5> 
                  <h5 class="ml-3 text-info"> {{ transCompInfoRels.contactEmail }}</h5>                  
                </div>
                <div class=" row ml-2 mt-2"> 
                  <h5 class="text-primary"> {{ $t('company.contactPhone') }} :</h5> 
                  <h5 class="ml-3 text-info"> {{ transCompInfoRels.contactPhone }}</h5>                  
                </div>
                <div class="ml-2 mt-2"> 
                  <h5 class="text-primary"> {{ $t('company.address') }} :</h5> 
                  <h6 class="text-info"> {{ transCompInfoRels.compAddress }}</h6>                  
                </div>
            </div>
          </b-modal>
          <b-modal id="transCompModalReqr" header-text-variant="primary" :title="$t('matchTx.transComp')" ok-only @hide="resetInfoModalTransCompReqr">
            <div class="card me-5" style=" width:30rem">
                <h6 class="card me-5"> {{ transCompInfoReqr.compNameLocal }}</h6>
                <h6 class="card me-5"> {{ transCompInfoReqr.compNameEng }}</h6>
                <div class=" row ml-2"> 
                  <h5 class="text-primary"> {{ $t('company.contactEmail') }} :</h5> 
                  <h5 class="ml-3 text-info"> {{ transCompInfoReqr.contactEmail }}</h5>                  
                </div>
                <div class=" row ml-2 mt-2"> 
                  <h5 class="text-primary"> {{ $t('company.contactPhone') }} :</h5> 
                  <h5 class="ml-3 text-info"> {{ transCompInfoReqr.contactPhone }}</h5>                  
                </div>
                <div class="ml-2 mt-2"> 
                  <h5 class="text-primary"> {{ $t('company.address') }} :</h5> 
                  <h6 class="text-info"> {{ transCompInfoReqr.compAddress }}</h6>                  
                </div>
            </div>
          </b-modal>
      </div>
    </div>
    <div class="divider"> </div>
    <div>
      <h2 class="mb-1 mt-4 f-w-600">{{ $t('matchTx.relsProposer') }}</h2>
      <b-table
        sticky-header
        head-variant="light"
        table-variant="info"
        show-empty
        responsive
        sort-icon-left
        stacked="md"
        :sort-by.sync="sortByRels"
        :sort-desc.sync="sortDescRels"
        :items="itemsRels"
        :fields="fieldsRels"
        :current-page="currentPageRels"
        :per-page="perPageRels"
      >
        <template #cell(addressReqr)="row" >
            <b-button  size="sm" v-b-popover.hover.top="row.item.contReqrAddress" variant="outline-info">
                {{ $t('matchTx.reqr') }}
            </b-button>
          </template>
          <template #cell(addressRels)="row" >
            <b-button  size="sm" v-b-popover.hover.top="row.item.contRelsAddress" variant="outline-info">
                {{ $t('matchTx.rels') }}
            </b-button>
          </template>
        <template #cell(contImageRels)="row" >
          <b-button  size="sm" @click="openModalImageRels(row.item, row.index, $event.target )" class="m-1" v-b-popover.hover.top="`${$t('container.contId')} : ${row.item.contId}`">
              {{ row.item.contNo }}
          </b-button>
        </template>
        <template #cell(transCompNameRels)="row" >
            <b-button  size="md" @click="openModalTransCompRels(row.item, row.index, $event.target )" class="m-1">
                {{ row.item.transCompId }}
            </b-button>
          </template>
        <template #empty>
            <h5>{{ $t('reuse.noRecord') }}</h5>
        </template>
      </b-table>
      <b-row>
        <div class="row col-sm-8 ">
          <b-col class="my-1 ml-3">
            <b-pagination
              v-model="currentPageRels"
              :total-rows="totalRowsRels"
              :per-page="perPageRels"
              align="fill"
              class="my-0"
            ></b-pagination>
          </b-col>   
          <b-col sm="3" md="6" class="my-1">
            <b-form-group
              :label="$t('require.perPage')"
              label-for="per-page-select"
              label-cols-sm="6"
              label-cols-md="4"
              label-cols-lg="3"
              label-align-sm="right"
              label-size="sm"
              class="mb-0 "
            > 
              <b-form-select
                id="per-page-select"
                v-model="perPageRels"
                :options="pageOptionsRels"
              ></b-form-select>
            </b-form-group>
          </b-col>          
        </div>
      </b-row>
    </div>
  </b-container>
  </div>
</template>
<script>
import {compInfo, getData,shipReviewRemark, matchTxsRels,bkgIdListAgentGroup, makeMatchTxTrStep2, matchTxsReqr,compNameListLogist,compIdByCompName ,updateStatus, updateActive,  sealNoListAgentGroup, updateMatchTx2StepN} from "../../firebase"
  export default {
    data() {
      return {
        compNameListLogist : [],
        selectedCompName : '',
        selectedCompId : '',
        itemsReqr: [],
        itemsRels: [],
        showSealNoModal: false,
        sealNos: [],
        selectedSealNo: '',
        currentSealNo: '',
        showTransferModal: false,
        bkgIds: [],
        selectedBkgId: '',
        selected_mTxId : '',
        fieldsReqr: [
          { key: 'mTxId', label: this.$t('matchTx.mTxId'), sortable: true, },  
          { key: 'bkgId', label: this.$t('require.bkgId'), sortable: true, },     
          { key: 'contImageReqr', label: this.$t('matchTx.contNo'), sortable: true, variant: 'info'},        
          { key: 'detDate', label: this.$t('matchTx.dt'), sortable: true, }, 
          { key: 'contType', label: this.$t('matchTx.type'), sortable: true, },
          { key: 'contSize', label: this.$t('matchTx.size'), sortable: true, },
          { key: 'contGrade', label: this.$t('matchTx.gradeTh'), sortable: true, },
          { key: 'maxGross', label: this.$t('matchTx.maxGross'), sortable: true, },
          { key: 'tare', label: this.$t('matchTx.tare'), sortable: true, },
          { key: 'sealNo', label: this.$t('matchTx.sealNo'), sortable: true, },
          { key: 'agent', label: this.$t('matchTx.agent'), sortable: true, },                
          { key: 'msReqr', label: this.$t('matchTx.matchStatus'), sortable: false, variant: 'warning',
            formatter: value => {
                return this.$t(`matchTx.${value}`)
          }}, 
          { key: 'jbReqr', label: this.$t('matchTx.jobStatus'), sortable: true, variant: 'warning',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          }}, 
          { key: 'shoreStatus', label: this.$t('matchTx.shore'), sortable: true, variant: 'danger',
            formatter: value => {
            return this.$t(`matchTx.${value}`)
          }},     
          { key: 'compNameLocalRels', label: this.$t('matchTx.compNameLocalRels'), sortable: true, variant: 'success', },                
          { key: 'jobTypeRels', label: this.$t('matchTx.jobTypeRels'), sortable: true, variant: 'success',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          }}, 
          { key: 'sRelsTS', label: this.$t('release.startRelsDate'), sortable: true, variant: 'success',
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY")
          }},  
          { key: 'addressRels', label: this.$t('matchTx.address'), sortable: false, variant: 'success',},           
          { key: 'compNameLocalReqr', label: this.$t('matchTx.compNameLocalReqr'), sortable: true, variant: 'primary',},                
          { key: 'jobTypeReqr', label: this.$t('matchTx.jobTypeReqr'), sortable: true, variant: 'primary',
              formatter: value => {
                return this.$t(`matchTx.${value}`)
          }},
          { key: 'sReqrTS', label: this.$t('require.startReqrDate'), sortable: true, variant: 'primary',
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY")
          }},    
          { key: 'addressReqr', label: this.$t('matchTx.address'), sortable: false,variant: 'primary' },          
          { key: 'distance', label: this.$t('matchTx.distance'), sortable: true, },            
          { key: 'transCompNameReqr', label: this.$t('matchTx.transComp'), sortable: true},  
          { key: 'transStatus', label: this.$t('matchTx.transStatus'), sortable: true, variant: 'danger',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          }}, 
          { key: 'timestamp', label: this.$t('shipApproval.date'), sortable: true, 
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY @ HH:mm")
          }},

        ],
        fieldsRels: [
          { key: 'mTxId', label: this.$t('matchTx.mTxId'), sortable: true, },  
          { key: 'bkgId', label: this.$t('require.bkgId'), sortable: true, },     
          { key: 'contImageRels', label: this.$t('matchTx.contNo'),sortable: true, variant: 'info'},            
          { key: 'detDate', label: this.$t('matchTx.dt'), sortable: true, }, 
          { key: 'contType', label: this.$t('matchTx.type'), sortable: true, },
          { key: 'contSize', label: this.$t('matchTx.size'), sortable: true, },
          { key: 'contGrade', label: this.$t('matchTx.gradeTh'), sortable: true, },
          { key: 'maxGross', label: this.$t('matchTx.maxGross'), sortable: true, },
          { key: 'tare', label: this.$t('matchTx.tare'), sortable: true, },
          { key: 'agent', label: this.$t('matchTx.agent'), sortable: true, },                 
          { key: 'msRels', label: this.$t('matchTx.matchStatus'), sortable: false,variant: 'warning',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          }}, 
          { key: 'jbRels', label: this.$t('matchTx.jobStatus'), sortable: true, variant: 'warning',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          }}, 
          { key: 'compNameLocalRels', label: this.$t('matchTx.compNameLocalRels'), sortable: true, variant: 'success'},                
          { key: 'jobTypeRels', label: this.$t('matchTx.jobTypeRels'), sortable: true,  variant: 'success',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          }},             
          { key: 'sRelsTS', label: this.$t('release.startRelsDate'), sortable: true,  variant: 'success',
            formatter: value => {
                return this.$moment(value).format("DD-MM-YY")
          }},  
          { key: 'addressRels', label: this.$t('matchTx.address'), sortable: false,  variant: 'success'}, 
          { key: 'compNameLocalReqr', label: this.$t('matchTx.compNameLocalReqr'), sortable: true, variant: 'primary'},                
          { key: 'jobTypeReqr', label: this.$t('matchTx.jobTypeReqr'), sortable: true, variant: 'primary',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          }},    
          { key: 'sReqrTS', label: this.$t('require.startReqrDate'), sortable: true, variant: 'primary',
            formatter: value => {
                return this.$moment(value).format("DD-MM-YY")
          }},    
          { key: 'addressReqr', label: this.$t('matchTx.address'), sortable: false ,variant: 'primary'},          
          // { key: 'contReqrAddress', label: this.$t('matchTx.contReqrAddress'), sortable: false, },
          { key: 'distance', label: this.$t('matchTx.distance'), sortable: true, },            
          { key: 'transCompNameRels', label: this.$t('matchTx.transComp'), sortable: true},   
          { key: 'transStatus', label: this.$t('matchTx.transStatus'), sortable: true, variant: 'danger',
            formatter: value => {
              return this.$t(`matchTx.${value}`)
          }}, 
          { key: 'timestamp', label: this.$t('shipApproval.date'), sortable: true, 
            formatter: value => {
              return this.$moment(value).format("DD-MM-YY @ HH:mm")
          }},
        ],
        totalRowsReqr: 1,
        currentPageReqr: 1,
        perPageReqr: 10,
        pageOptionsReqr: [5, 10, 15, { value: 100, text: "Show a lot" }],
        sortByReqr: 'timestamp',
        sortDescReqr: true,
        actReqrAttachSealModal: {
          id: 'reqrAttachSeal-modal',
          title: this.$t('matchTx.attachSeal'),
        },
        actReqrTransferModal: {
          id: 'reqrTransfer-modal',
          title: this.$t('matchTx.transfer'),
        },
        totalRowsRels: 1,
        currentPageRels: 1,
        perPageRels: 10,
        pageOptionsRels: [5, 10, 15, { value: 100, text: "Show a lot" }],
        sortByRels: 'timestamp',
        sortDescRels: true,
        imageUriModalReqr: [],
        modalTitleReqr : '',
        modalContIdReqr: '',
        imageUriModalRels: [],
        modalTitleRels : '',
        modalContIdRels: '',
        shipsRejectRemarkRels : '',
        shipsRejectRemarkReqr : '',
        transCompInfoRels : '',
        transCompInfoReqr : '' 
      }
    },
    computed: {
    },
    mounted() {
      compNameListLogist((res)=>{
            this.compNameListLogist = res
        })
    },
    methods: {
      async matchTxAdmin(){
        if (this.selectedCompName) {
          await compIdByCompName(this.selectedCompName , async(selCompId)=>{
            this.selectedCompId = selCompId
            matchTxsReqr(selCompId , (res)=>{
              this.itemsReqr = res
              this.totalRowsReqr = res.length
            })
            matchTxsRels(selCompId , (res)=>{
              this.itemsRels = res
              this.totalRowsRels = res.length
            })          
          })          
        }
      },
      async refreshMatchTx() {
        this.selectedSealNo = ""
        this.selected_mTxId = ""
        await matchTxsReqr(this.selectedCompId , (res)=>{
          this.itemsReqr = res
          this.totalRowsReqr = res.length
        })
         await matchTxsRels(this.selectedCompId , (res)=>{
          this.itemsRels = res
          this.totalRowsRels = res.length
        })
      },
      async openModalImageReqr(item, index, button) {
        await getData( 'Container' , 'contId' , item.contId, (res)=>{
            this.imageUriModalReqr = res[0].url6
            this.modalTitleReqr = `${this.$t('container.contNo')} : ${res[0].contNo}`
            this.modalContIdReqr = res[0].contId
            this.$root.$emit('bv::show::modal', "contModalReqr" , button)
        })
      },
      resetInfoModalReqr() {
        this.modalTitleReqr = ''
        this.imageUriModalReqr = []
      },
      async openModalImageRels(item, index, button) {
        await getData( 'Container', 'contId', item.contId ,(res)=>{
          this.imageUriModalRels = res[0].url6
          this.modalTitleRels = `${this.$t('container.contNo')} : ${res[0].contNo}`
          this.modalContIdRels = res[0].contId
          this.$root.$emit('bv::show::modal', "contModalRels" , button)          
        })
      },
      resetInfoModalRels() {
        this.modalTitleRels = ''
        this.imageUriModalRels = []
      },
      async openModalTransCompRels(item, index, button) {
        await compInfo(item.transCompId , (res)=>{
          this.transCompInfoRels = res
        })
        this.$root.$emit('bv::show::modal', "transCompModalRels" , button)
      },
      resetInfoModalTransCompRels() {
        this.transCompInfoRels = ''
      },      
      async openModalTransCompReqr(item, index, button) {
        await compInfo(item.transCompId , (res)=>{
          this.transCompInfoReqr = res
        })  
        this.$root.$emit('bv::show::modal', "transCompModalReqr" , button)
      },
      resetInfoModalTransCompReqr() {
        this.transCompInfoReqr = ''
      },
      async openModalViewShipsRejectRels(item, index, button) {
        await shipReviewRemark(item.mTxId , (res)=>{
          this.shipsRejectRemarkRels = res
        })  
        this.$root.$emit('bv::show::modal', "viewShipsRejectModalRels" , button)
        },

      resetInfoModalShipsRejectRels() {
        this.shipsRejectRemarkRels = ''
      },

      async openModalViewShipsRejectReqr(item, index, button) {
        // console.log(`openModalViewShipsRejectReqr => ${JSON.stringify(item , null , 2)}`)
        await shipReviewRemark(item.mTxId , (res)=>{
          this.shipsRejectRemarkReqr = res
        })  
        this.$root.$emit('bv::show::modal', "viewShipsRejectModalReqr" , button)
      },

      resetInfoModalShipsRejectReqr() {
        this.shipsRejectRemarkReqr = ''
      },
      scrollLeft() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },  
        scrollLeftS1() {
        this.$refs.scrollContainer.scrollBy({
            left: -window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        }, 
        scrollRight() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 1.0,
            behavior: 'smooth'
        });
        },
        scrollRightS1() {
        this.$refs.scrollContainer.scrollBy({
            left: window.innerWidth * 0.2,
            behavior: 'smooth'
        });
        },
    }
  }
</script>
<style scoped>
.divider {
  height: 1px;
  background-color: #0f0f0f;
  margin:5px
}
.gradient-yg {
   background: linear-gradient(135deg, yellow, green);
 }
.display-image {
  width: 100%;
  height: 450px;
  object-fit: contain;
  border-radius: 8px;
  background-color: #f5f5f5;
}
.dashboard {
  padding: 10px;
  max-width: 100%;
  overflow-x: hidden;
}
.image-scroll-container {
  position: relative;
  margin: 20px 0;
}

.image-scroll {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
  width: 100%;
}

.image-scroll::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome/Safari */
}

.image-item {
  flex: 0 0 100%;
  scroll-snap-align: start;
  position: relative;
  padding: 0 5px;
  box-sizing: border-box;
}

  .image-counter {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 14px;
}

.no-images {
  text-align: center;
  width: 100%;
  padding: 50px 0;
  color: #666;
  font-style: italic;
  font-size: 16px;
}

.scroll-controls {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

.scroll-btn {
  background-color: #42b983;
  color: white;
  border: none;
  padding: 8px 15px;
  margin: 0 5px;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}
</style>